import Image from "next/image";
import styled from "styled-components";

export const SearchSectionsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacers["2M"]};
`;

export const SearchSectionWrapper = styled.section`
  display: flex;
  flex-direction: column;
  row-gap: ${({ theme }) => theme.spacers["2M"]};
`;

export const SearchSectionTitleWrapper = styled.div`
  padding: 0 ${({ theme }) => theme.spacers.L};
`;

export const SearchSectionItemWrapper = styled.li`
  a {
    display: flex;
    align-items: center;
    column-gap: ${({ theme }) => theme.spacers.M};
    padding: ${({ theme }) => theme.spacers.M} ${({ theme }) => theme.spacers.L};
    min-height: ${({ theme }) => theme.spacers["5XL"]};
    color: ${({ theme }) => theme.colors.text.darkerGrey};
    transition: background-color 0.2s;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      background-color: ${({ theme }) => theme.colors.background.superLightGrey};
    }
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex: 1;
`;

export const SearchSectionItemTitle = styled.span`
  ${({ theme }) => theme.typography.RegularParagraph}
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  white-space: nowrap;
  overflow: hidden; 
  text-overflow: ellipsis;
  max-width: 100%;
  display: inline-block;
  
  mark {
    font-weight: 700;
    background: inherit;
  }
`;

export const RightIcon = styled.div`
  color: ${({ theme }) => theme.colors.text.lightGrey};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NoResultsParagraph = styled.p`
  ${({ theme }) => theme.typography.RegularParagraph}
  color: ${({ theme }) => theme.colors.text.darkerGrey};
  padding: ${({ theme }) => `${theme.spacers.M} ${theme.spacers.L}`};
`;

export const SearchProductItemImage = styled(Image)`
  object-fit: contain;
`;
